import { css } from "@vitality-ds/system";
export default css({
  display: "flex",
  flexDirection: "column"
});